/* eslint-disable camelcase */
/* eslint-disable no-await-in-loop */
import * as React from 'react';
import * as api from 'api';
import { useSignIn } from '@clerk/clerk-react';
import wait from './wait';

const useRegisterUser = () => {
  const [user, setUser] = React.useState(null);
  const [error, setError] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const { signIn, setActive } = useSignIn();
  let clerkTokenResponse;
  let attempts = 0;

  React.useEffect(() => {
    const authorizeUser = async () => {
      setError('');
      setIsError(false);
      setIsSuccess(false);
      setIsLoading(true);
      try {
        const { email, first_name, last_name, gender, accept_agb } = user;
        const requestBody = {
          data: {
            attributes: {
              email,
              first_name,
              last_name,
              gender,
              accept_agb,
              source: 'Teacher Sign-up CCR',
            },
          },
        };

        const newTeacherResponse = await api.userApi.post('/teachers/', requestBody);
        const teacherIdentityId = newTeacherResponse.data.data.attributes.identityId;
        const otpToken = newTeacherResponse.headers['x-otp-token'];

        do {
          await wait(1000);
          clerkTokenResponse = await api.obtainClerkToken(teacherIdentityId, otpToken);
          attempts += 1;
        } while (!clerkTokenResponse.data.token && attempts <= 30);
        const clerkToken = clerkTokenResponse.data.token;

        if (!clerkToken) {
          throw new Error('Maximum number of attempts reached');
        }

        const signInAttempt = await signIn.create({
          strategy: 'ticket',
          ticket: clerkToken,
        });

        if (signInAttempt.status === 'complete') {
          setActive({
            session: signInAttempt.createdSessionId,
          });
        } else {
          throw new Error(JSON.stringify(signInAttempt, null, 2));
        }
        localStorage.setItem('user_uuid', newTeacherResponse.data.data.id);

        setIsLoading(false);
        setIsSuccess(true);
      } catch (err) {
        setIsError(true);
        setError(err.message);
        setIsLoading(false);
      }
    };
    if (user) authorizeUser();
  }, [user]);
  return [{ isLoading, isSuccess, isError, error }, setUser];
};

export default useRegisterUser;
